import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MainService } from 'app/resources/services/index';
import { PoliticaTermoService } from 'app/resources/services/politica-termo.service';

type imagem = { arquivo: string, alt: string };
declare var $: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})

export class HomeComponent implements OnInit {

  public isCustomized: boolean;

  constructor(
    public mainService: MainService,
    public router: Router,
    public politicaTermoService: PoliticaTermoService
  ) {
    if (location.pathname.replace(/\//g, '')) {
      this.isCustomized = true;
    }
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    if (this.politicaTermoService.isAcceptedPoliciesAndTerms()) {
      // this.avisoTelefone();
      this.abrirModal();
    }
  }

  public abrirModal(): void {
    $('#myModal').modal('show');
    $('#myModal').on('hidden.bs.modal');
  }

  // Inserir avisos quando necessario
  // public avisoTelefone() {
  //   if (this.mainService.permissionService.hasPermission('funcionalidade:ted') || this.mainService.permissionService.hasPermission('funcionalidade:ted_cartao') || this.mainService.cartaoService.cartao.produto.bandeira) {
  // const imagem1: imagem = { arquivo: '../../img/avisos/Best+Pontos_Comunicado_Transferências.jpg', alt: 'Comunicado Carnaval.' };
  // const mobile: imagem = { arquivo: '../../img/avisos/Best+Pontos_Comunicado_Gestor_Mobile.jpg', alt: 'Alteração de Telefone.' };
  // this.mainService.aviso.alerta(mobile);
  //   }
  // }
}




// WEBPACK FOOTER //
// ./src/app/home/home.component.ts